import React from "react";
import styled from "styled-components";
import { RecordCard } from "../records/RecordCard";
import { ParsedRecord } from "../../types/records";
import { formatDate, formatKey } from "../../utils/searchUtils";

interface DeviceDetailsProps {
  selectedDevice: string;
  records: ParsedRecord[];
}

const RecordsList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin: 24px 0;
`;

export const DeviceDetails: React.FC<DeviceDetailsProps> = ({
  selectedDevice,
  records,
}) => {
  const filteredRecords = records.filter((record) => {
    if (record.blockchainData && record.blockchainData.hash) {
      return record.blockchainData.hash === selectedDevice;
    }

    return record.deviceInfo?.identifier === selectedDevice;
  });

  if (filteredRecords.length === 0) {
    return null;
  }

  return (
    <>
      <RecordsList>
        {filteredRecords.map((record, index) => (
          <RecordCard
            key={index}
            record={record}
            index={index}
            formatDate={formatDate}
            formatKey={formatKey}
            isExpanded={true}
            blockchainData={record.blockchainData}
          />
        ))}
      </RecordsList>
    </>
  );
};
